import antdFR from "antd/lib/locale-provider/fr_FR";
import frMessages from "../locales/fr_FR.json";

const FrLang = {
  messages: {
    ...frMessages
  },
  antd: antdFR,
  locale: 'fr-FR',
};
export default FrLang;
